/* =========================================================================
   b2g2-drawer.js — cart drawer controller for a theme with no native drawer
   -------------------------------------------------------------------------
   - Intercepts the cart icon (a[href*="/cart"]) -> opens drawer instead of /cart
   - Detects ANY add-to-cart (fetch OR XMLHttpRequest to /cart/add) -> opens drawer
   - Renders line items from /cart.js (qty steppers, remove, gift flag)
   - Leaves existing theme handlers (fcgAtcSubmit, ajax-product-form) untouched
   - Works alongside b2g2-cart.js (tracker + gift picker). Load order:
       b2g2-config.liquid -> b2g2-cart.js -> b2g2-drawer.js  (this file is fine last)
   ========================================================================= */
(function () {
  "use strict";

  var CFG = window.B2G2_CONFIG || {};
  var giftProp = CFG.giftProperty || "_b2g2_free_gift";

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var drawer = $("[data-b2g2-drawer]");
  if (!drawer) { console.warn("[b2g2-drawer] drawer markup missing"); return; }

  var panelOpen = false;

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (CFG.moneyFormat || "${{amount}}");
    var amount = (cents / 100).toFixed(2);
    // handle the common {{amount}} token; fallback simple
    if (fmt.indexOf("{{amount}}") !== -1) return fmt.replace("{{amount}}", amount);
    if (fmt.indexOf("{{amount_no_decimals}}") !== -1) return fmt.replace("{{amount_no_decimals}}", Math.round(cents / 100));
    return "$" + amount;
  }

  /* ---------- open / close ---------- */
  function openDrawer() {
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("is-open");
    document.documentElement.classList.add("b2g2-drawer-locked");
    panelOpen = true;
    render();
  }
  function closeDrawer() {
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("b2g2-drawer-locked");
    panelOpen = false;
  }

  /* ---------- fetch cart ---------- */
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }
  function changeQty(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // Swap a cart line to a different variant of the same product.
  // Shopify can't mutate a line's variant in place, so: remove old, add new,
  // preserving quantity and any line properties (e.g. free-gift flag).
  function changeVariant(line, newVariantId) {
    var qty = line.quantity;
    var props = line.properties && Object.keys(line.properties).length ? line.properties : null;
    // remove old line first (by key), then add the new variant
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    }).then(function (r) { return r.json(); })
      .then(function () {
        var item = { id: newVariantId, quantity: qty };
        if (props) item.properties = props;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) { return r.json(); });
      });
  }

  /* ---------- render line items ---------- */
  function render() {
    return getCart().then(function (cart) {
      var wrap = $("[data-b2g2-items]");
      var tpl = $("[data-b2g2-item-template]");
      var empty = $("[data-b2g2-empty]");
      var footer = $("[data-b2g2-footer]");
      if (!wrap || !tpl) return cart;

      wrap.innerHTML = "";

      if (!cart.items.length) {
        if (empty) empty.hidden = false;
        if (footer) footer.hidden = true;
      } else {
        if (empty) empty.hidden = true;
        if (footer) footer.hidden = false;
      }

      cart.items.forEach(function (line) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        var isGift = line.properties && (line.properties[giftProp] === "true" || line.properties[giftProp] === true);

        var img = $(".b2g2-item__img", node);
        img.src = line.image ? line.image.replace(/(\.[^.\/]+)(\?|$)/, "_150x$1$2") : "";
        img.alt = line.product_title;

        var link = $("[data-item-url]", node);
        if (link) link.href = line.url;
        var titleEl = $("[data-item-title]", node);
        titleEl.textContent = line.product_title;
        titleEl.href = line.url;

        var variantEl = $("[data-item-variant]", node);
        var sizeSel = $("[data-item-size]", node);
        var siblings = (CFG.variantsByProduct && CFG.variantsByProduct[line.product_id]) || null;

        // If we know this product's variants and there's more than one, offer a size dropdown.
        if (siblings && siblings.length > 1 && line.variant_title && line.variant_title !== "Default Title") {
          if (variantEl) variantEl.hidden = true;
          if (sizeSel) {
            sizeSel.hidden = false;
            sizeSel.innerHTML = "";
            siblings.forEach(function (v) {
              var opt = document.createElement("option");
              opt.value = v.id;
              opt.textContent = v.available ? v.title : (v.title + " (sold out)");
              if (!v.available) opt.disabled = true;
              if (v.id === line.variant_id) opt.selected = true;
              sizeSel.appendChild(opt);
            });
            sizeSel.addEventListener("change", function () {
              var newId = parseInt(sizeSel.value, 10);
              if (!newId || newId === line.variant_id) return;
              sizeSel.disabled = true;
              changeVariant(line, newId).then(afterMutate).catch(function () { sizeSel.disabled = false; });
            });
          }
        } else {
          if (variantEl) variantEl.textContent = (line.variant_title && line.variant_title !== "Default Title") ? line.variant_title : "";
          if (sizeSel) sizeSel.hidden = true;
        }

        var priceEl = $("[data-item-price]", node);
        priceEl.textContent = isGift ? "FREE" : money(line.final_line_price);
        if (isGift) priceEl.classList.add("is-free");

        var qtyVal = $("[data-item-qty]", node);
        qtyVal.textContent = line.quantity;

        var giftFlag = $("[data-item-giftflag]", node);
        if (giftFlag) giftFlag.hidden = !isGift;

        // Gift lines: hide qty stepper (they're auto-managed), keep remove
        if (isGift) {
          var qwrap = $("[data-item-qtywrap]", node);
          if (qwrap) qwrap.style.visibility = "hidden";
        }

        // wire qty + remove with the line key
        $all("[data-b2g2-qty]", node).forEach(function (btn) {
          btn.addEventListener("click", function () {
            var delta = parseInt(btn.getAttribute("data-b2g2-qty"), 10);
            var next = Math.max(0, line.quantity + delta);
            changeQty(line.key, next).then(afterMutate);
          });
        });
        var rm = $("[data-b2g2-remove]", node);
        if (rm) rm.addEventListener("click", function () { changeQty(line.key, 0).then(afterMutate); });

        wrap.appendChild(node);
      });

      var totalEl = $("[data-b2g2-total]");
      if (totalEl) totalEl.textContent = money(cart.total_price);

      // let b2g2-cart.js recompute tracker + gift picker
      if (window.B2G2 && window.B2G2.refresh) window.B2G2.refresh();
      document.dispatchEvent(new CustomEvent("b2g2:drawer-rendered", { detail: { cart: cart } }));
      return cart;
    });
  }

  function afterMutate() {
    render();
    updateIconCount();
  }

  /* ---------- cart icon count badge ---------- */
  function updateIconCount() {
    getCart().then(function (cart) {
      $all("[data-b2g2-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  /* ---------- intercept cart icon clicks ---------- */
  document.addEventListener("click", function (e) {
    var closeBtn = e.target.closest && e.target.closest("[data-b2g2-close]");
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }

    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute("href") || "";
    // Match the theme's cart icon: href={{ routes.cart_url }} => "/cart"
    // Open drawer instead of navigating. Don't hijack checkout links.
    var isCartLink = /\/cart\/?($|\?)/.test(href) && href.indexOf("checkout") === -1;
    if (isCartLink && !link.hasAttribute("data-b2g2-checkout")) {
      e.preventDefault();
      openDrawer();
    }
  });

  /* ---------- detect add-to-cart via fetch ---------- */
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] && args[0].url ? args[0].url : args[0];
    var p = _fetch.apply(this, args);
    if (typeof url === "string" && /\/cart\/add(\.js)?/.test(url)) {
      p.then(function (res) {
        // clone not needed; just react on success
        if (res && res.ok !== false) {
          setTimeout(function () { openDrawer(); updateIconCount(); }, 80);
        }
      }).catch(function () {});
    } else if (typeof url === "string" && /\/cart\/(change|update|clear)/.test(url)) {
      p.then(function () { if (panelOpen) setTimeout(render, 80); updateIconCount(); }).catch(function () {});
    }
    return p;
  };

  /* ---------- detect add-to-cart via XMLHttpRequest (in case fcgAtcSubmit uses XHR) ---------- */
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__b2g2_url = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    var url = self.__b2g2_url || "";
    if (/\/cart\/add(\.js)?/.test(url)) {
      self.addEventListener("load", function () {
        if (self.status >= 200 && self.status < 300) {
          setTimeout(function () { openDrawer(); updateIconCount(); }, 80);
        }
      });
    } else if (/\/cart\/(change|update|clear)/.test(url)) {
      self.addEventListener("load", function () { if (panelOpen) setTimeout(render, 80); updateIconCount(); });
    }
    return _send.apply(this, arguments);
  };

  /* ---------- fallback: catch native (non-AJAX) /cart/add form submits ----------
     If any add-to-cart form ever submits natively (no JS), convert to AJAX so the
     drawer can open instead of a full page redirect to /cart. Existing AJAX forms
     (fcgAtcSubmit returns false; ajax-product-form preventDefaults) won't reach here. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.getAttribute("action") == null) return;
    if (!/\/cart\/add/.test(form.getAttribute("action"))) return;
    if (e.defaultPrevented) return; // an existing handler already took it

    // Native submit about to happen -> intercept, do AJAX, open drawer.
    e.preventDefault();
    var data = new FormData(form);
    fetch("/cart/add.js", { method: "POST", body: data, headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function () { openDrawer(); updateIconCount(); })
      .catch(function () { form.submit(); }); // last resort: let it go native
  }, true); // capture phase, but bails if defaultPrevented by theme handlers

  /* ---------- Esc to close ---------- */
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && panelOpen) closeDrawer(); });

  /* ---------- init ---------- */
  updateIconCount();
  window.B2G2Drawer = { open: openDrawer, close: closeDrawer, render: render };
})();